import { create } from 'zustand';

interface NotificationsInvalidationState {
  version: number;
  bump: () => void;
}

/**
 * A tiny global invalidation signal to re-fetch notifications after mutations
 * (mark as read, delete, clear all, ...).
 */
export const useNotificationsInvalidationStore = create<NotificationsInvalidationState>((set) => ({
  version: 0,
  bump: () => set((s) => ({ version: s.version + 1 })),
}));

